"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThumbsUpTitle = exports.sortData = exports.processTime = exports.searchData = exports.getFutureExpense = exports.getEditAssumptionsInitialState = exports.getCurrentAge = exports.getYearMoment = exports.getBirthYear = exports.getDate = void 0;
var reducers_1 = require("./../redux/reducers");
var sliderConstants_1 = require("../constants/sliderConstants");
var redux_1 = require("../redux");
var moment_1 = __importDefault(require("moment"));
var constants_1 = require("../constants");
var getDate = function () { return new Date(); };
exports.getDate = getDate;
var getBirthYear = function (dob) { return parseInt(dob.split('-')[0], 10); };
exports.getBirthYear = getBirthYear;
var getYearMoment = function (val) { return +(0, moment_1.default)(val).format('YYYY'); };
exports.getYearMoment = getYearMoment;
var getCurrentAge = function (dob) {
    return (0, moment_1.default)().diff(dob, 'years');
};
exports.getCurrentAge = getCurrentAge;
// Slider options object intialiser helper
var getConfig = function (title, min, max, type) { return ({
    title: title,
    min: min,
    max: max,
    type: type,
}); };
// Create the slider options config object
var getEditAssumptionsInitialState = function (token, userData) { return __awaiter(void 0, void 0, void 0, function () {
    var dob, current_age, retireValue, lifeExpectancy, contri, futureExpense, _a, socialSecurity, openingBalance, strategyIndex, retireAge, lifeExp, contribution, currentAge, expenses, slider_options;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                dob = (userData === null || userData === void 0 ? void 0 : userData.dob) || '1993-01-01';
                current_age = (0, exports.getCurrentAge)(dob);
                retireValue = (userData === null || userData === void 0 ? void 0 : userData.retireAge) || sliderConstants_1.RETIRE_AGE.VALUE;
                lifeExpectancy = (userData === null || userData === void 0 ? void 0 : userData.lifeExpectancy) || sliderConstants_1.LIFE_EXP.VALUE;
                contri = (userData === null || userData === void 0 ? void 0 : userData.annualContribution) || sliderConstants_1.CONTRIBUTION.VALUE;
                if (!(token && (userData === null || userData === void 0 ? void 0 : userData.isLinked))) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, exports.getFutureExpense)((0, exports.getYearMoment)(dob) + retireValue)];
            case 1:
                _a = (_b.sent()) ||
                    (userData === null || userData === void 0 ? void 0 : userData.futureExpense) ||
                    sliderConstants_1.EXPENSES.VALUE;
                return [3 /*break*/, 3];
            case 2:
                _a = sliderConstants_1.EXPENSES.VALUE;
                _b.label = 3;
            case 3:
                futureExpense = _a;
                return [4 /*yield*/, reducers_1.store.dispatch((0, redux_1.get_future_expense_planner)((0, exports.getYearMoment)(dob) + retireValue + ''))];
            case 4:
                socialSecurity = ((_b.sent()) || { socialSecurity: [] }).socialSecurity;
                openingBalance = (userData === null || userData === void 0 ? void 0 : userData.approx_401k_balance) || 1000;
                strategyIndex = (userData === null || userData === void 0 ? void 0 : userData.strategy) || 0;
                retireAge = {
                    config: getConfig(sliderConstants_1.RETIRE_AGE.TITLE, current_age + 1, sliderConstants_1.RETIRE_AGE.MAX, sliderConstants_1.RETIRE_AGE.TYPE),
                    value: retireValue,
                };
                lifeExp = {
                    config: getConfig(sliderConstants_1.LIFE_EXP.TITLE, retireValue + 1, sliderConstants_1.LIFE_EXP.MAX, sliderConstants_1.LIFE_EXP.TYPE),
                    value: lifeExpectancy,
                };
                contribution = {
                    config: getConfig.apply(void 0, Object.values(sliderConstants_1.CONTRIBUTION)),
                    value: contri,
                };
                currentAge = {
                    config: getConfig.apply(void 0, Object.values(sliderConstants_1.CURRENT_AGE)),
                    value: current_age,
                };
                expenses = {
                    config: getConfig.apply(void 0, Object.values(sliderConstants_1.EXPENSES)),
                    value: futureExpense,
                };
                slider_options = __assign(__assign(__assign({}, (token && (userData === null || userData === void 0 ? void 0 : userData.dob) ? {} : { currentAge: currentAge })), { retireAge: retireAge, lifeExp: lifeExp, contribution: contribution }), (token && (userData === null || userData === void 0 ? void 0 : userData.isLinked) ? {} : { expenses: expenses }));
                return [2 /*return*/, {
                        sliderOptions: slider_options,
                        openingBalance: openingBalance,
                        strategyIndex: strategyIndex,
                        expense_home: futureExpense,
                        socialSecurity: socialSecurity,
                    }];
        }
    });
}); };
exports.getEditAssumptionsInitialState = getEditAssumptionsInitialState;
var getFutureExpense = function (fromYear) { return __awaiter(void 0, void 0, void 0, function () {
    var futureExpenses, expenses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, reducers_1.store.dispatch((0, redux_1.get_future_expense_planner)(fromYear))];
            case 1:
                futureExpenses = (_a.sent()).futureExpenses;
                expenses = 0;
                futureExpenses === null || futureExpenses === void 0 ? void 0 : futureExpenses.map(function (item) {
                    if (item.category === 'Social Security') {
                        return null;
                    }
                    else {
                        expenses += item.future ? +item.future : 0;
                    }
                });
                return [2 /*return*/, expenses * Math.pow(constants_1.inflation, (+fromYear - +(0, moment_1.default)().format('YYYY')))];
        }
    });
}); };
exports.getFutureExpense = getFutureExpense;
// Search accord data
var searchData = function (data, key, value, index, dataParam) {
    var regex = new RegExp("^".concat(value, "|").concat(value), 'i');
    if (index) {
        return data.filter(function (x) { return regex.test(x[key]); });
    }
    var filteredData = [];
    var flag = false;
    for (var i = 0; i < data.length; i += 1) {
        var temp = data[i][dataParam ? dataParam : 'list'].filter(function (item) {
            return regex.test(item[key]);
        });
        var dataItem = __assign({}, data[i]);
        dataItem[dataParam ? dataParam : 'list'] = temp;
        if (temp.length) {
            if (!flag) {
                dataItem.selected = true;
            }
            filteredData.push(dataItem);
            flag = true;
        }
    }
    return filteredData;
};
exports.searchData = searchData;
function compare(a, b, prop, process, order) {
    if (process(a[prop]) < process(b[prop])) {
        return 1 * order;
    }
    if (process(a[prop]) > process(b[prop])) {
        return -1 * order;
    }
    return 0;
}
// Convert to Date from string
var processTime = function (x) {
    var a = x.split(' ');
    var d = a[0].split('-');
    var t;
    if (a[1]) {
        t = a[1].split(':');
    }
    return t
        ? new Date(d[0], d[1] - 1, d[2], t[0], t[1], t[2])
        : new Date(d[0], d[1] - 1, d[2]);
};
exports.processTime = processTime;
// Sort accord data
var sortData = function (data, type, propArray) {
    switch (type) {
        case 0: {
            // Sort acsending value wise
            return data.sort(function (a, b) {
                return compare(a, b, propArray[type], function (x) { return parseFloat(x); }, 1);
            });
        }
        case 1: {
            // Sort desending value wise
            return data.sort(function (a, b) {
                return compare(a, b, propArray[type], function (x) { return parseFloat(x); }, -1);
            });
        }
        case 2: {
            // Sort acsending time wise
            return data.sort(function (a, b) {
                return compare(a, b, propArray[type], function (x) { return (0, exports.processTime)(x); }, 1);
            });
        }
        case 3: {
            // Sort desending time wise
            return data.sort(function (a, b) {
                return compare(a, b, propArray[type], function (x) { return (0, exports.processTime)(x); }, -1);
            });
        }
        default:
            return data;
    }
};
exports.sortData = sortData;
var getThumbsUpTitle = function (type) {
    switch (type) {
        case 'contribution':
            return 'Annual Contribution';
        case 'retireAge':
            return 'Retirement Age';
        case 'strategy':
            return 'Investment Strategy';
    }
};
exports.getThumbsUpTitle = getThumbsUpTitle;
